import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

class Navbar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      username: localStorage.getItem('username')
    };
  }

  componentWillReceiveProps() {
    this.setState({
      'username': localStorage.getItem('username')
    });
  }

  renderUserLinks() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
      return (
        <span>
          <NavLink className="dropdown-item" activeClassName="active" to="/user/profile">
            <i className="fa fa-user-circle"></i> Hesap
          </NavLink>
          <NavLink className="dropdown-item" activeClassName="active" to="/user/logout">
            <i className="fa fa-sign-out"></i> Çıkış
          </NavLink>
        </span>
      );
    }
    else {
      return (
        <span>
          <NavLink className="dropdown-item" activeClassName="active" to="/user/login">
            <i className="fa fa-sign-in"></i> Giriş
          </NavLink>
        </span>
      );
    }
  }

  renderUserName() {
    var loggedIn = localStorage.getItem('auth');
    if (loggedIn) {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          {userLinkTitle} 
        </span>
      );
    }
    else {
    var userLinkTitle = localStorage.getItem('username');
      return (
        <span>
          Kullanici {userLinkTitle} 
        </span>
      );
    }
  }



  render() {

    var userLinkTitle = this.state.username ? this.state.username : 'Kullanici';

    return (

      <div className="row pt-4 pb-5">
        <div className="col">
        
        
        
        
          <nav className="navbar navbar-expand-lg">
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <NavLink exact className="nav-link" activeClassName="active" to="/">
                    <img alt="" src="/images/abbott-logo.svg" height="48" />
                  </NavLink>
                </li>
              </ul>
          
          	<img alt="" src="/images/epibiotland-logo.svg" height="64" />
            
          </nav>
          

        </div>
      </div>
    );
  }
}

export default Navbar



// WEBPACK FOOTER //
// src/components/navbar.jsx